// import on, { once } from '../util/elements/on'
// import destroys from '../util/elements/destroys'

// export default function (Site, $) {
//   Site.widget('image', {
//     _create () {
//       destroys(this)
//       this.image = this.element.find('img')
//       this.loaded = false
//       this.loadedCallbacks = []

//       if (this.options.init) {
//         this.init()
//       }

//       this.loaded = this.loaded.bind(this)
//     },
//     _transitionIn () {
//       this.updateSize()
//       return 0
//     },
//     loaded () {
//       return new Promise(resolve => {
//         /* Already loaded */
//         if (this.loaded) {
//           resolve(this)
//         } else {
//           this.loadedCallbacks.push(() => resolve(this))
//         }
//       })
//     },
//     init () {
//       if (this.in) return
//       this.in = true
//       window.requestAnimationFrame(() => {
//         const { src, srcset } = this.image.data()

//         this.updateSize()

//         this.destroys(
//           once(this.image, 'load', () => {
//             this.loaded = true
//             this.image.addClass('in')
//             this.loadedCallbacks.forEach(fn => fn())
//           })
//         )

//         this.image.attr('srcset', srcset)
//         this.image.attr('src', src)

//         const onResize = on($(window), 'resize', e => this.updateSize())

//         this.destroys(onResize)
//       })
//     },
//     updateSize () {
//       /* Updates the sizes attribute so the browser downloads the correct one */
//       this.image.attr(
//         'sizes',
//         `${(this.element.width() / window.innerWidth) * 100}vw`
//       )
//     }
//   })
// }

import on, { once } from '../util/elements/on'
import destroys from '../util/elements/destroys'

export default function (Site, $) {
  Site.widget('image', {
    _create () {
      destroys(this)
      this.image = this.element.find('img')

      if (this.options.init) {
        this.init()
      }
    },
    _transitionIn () {
      this.updateSize()
      return 0
    },
    init () {
      if (this.in) return
      this.in = true
      window.requestAnimationFrame(() => {
        const { src, srcset } = this.image.data()

        this.updateSize()

        this.destroys(once(this.image, 'load', () => this.image.addClass('in')))

        this.image.attr('srcset', srcset)
        this.image.attr('src', src)

        const onResize = on($(window), 'resize', e => this.updateSize())

        this.destroys(onResize)
      })
    },
    updateSize () {
      /* Updates the sizes attribute so the browser downloads the correct one */
      this.image.attr(
        'sizes',
        `${(this.element.width() / window.innerWidth) * 100}vw`
      )
    }
  })
}
